import { decode } from 'html-entities';

import { uri } from 'utils';
import { HEADER_SEARCH_QUERY_PARAMETER_ID } from '../../search/constants';

/**
 * @param {string} searchValue
 * @param {string} url
 * @returns {boolean}
 */
const searchValueIsChanged = (searchValue, url) => {
    const urlParameter = uri.getParams(url)[HEADER_SEARCH_QUERY_PARAMETER_ID];
    const sanitized = decode(urlParameter);

    return sanitized !== searchValue;
};

export default searchValueIsChanged;
